module.exports = __webpack_public_path__ + "static/media/diddy-kong.a571efdd.png";